









  import { Component, Vue, Watch } from "vue-property-decorator";


// 组件
import Table from "./components/Table.vue";

@Component({
  components: {
    Table,
  },
})
export default class HelloWorld extends Vue {



  /**
   * 生命周期
   */
  mounted() {
    let table: any = this.$refs.table;
    table.getData();
  }
}
